import { useTranslation } from "react-i18next";

export default function Breadcrumb() {
  const { t } = useTranslation("home");

  return (
    <nav aria-label="Breadcrumb" className="bg-brand-cream border-b border-brand-border">
      <div className="max-w-[1024px] mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-2 font-geist text-sm text-brand-text/60 flex-wrap">
          <li>
            <a href="/" className="hover:text-brand-text transition-colors">
              {t("breadcrumb.home")}
            </a>
          </li>
          <li aria-hidden="true">/</li>
          <li className="text-brand-text font-medium" aria-current="page">
            Blog
          </li>
        </ol>
      </div>
    </nav>
  );
}